import { Action, createReducer, on } from '@ngrx/store';
import { IUserRolesResponse } from '../models/user-roles.model';
import { fromStaticDataLegalEntityUserRolesActions } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';

export const legalEntityUserRolesFeatureKey = 'legalEntityUserRoles';

export interface LegalEntityUserRolesState {
  legalEntityUserRolesResponse: IUserRolesResponse[];
  legalEntityUserRolesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: LegalEntityUserRolesState = {
  legalEntityUserRolesFailure: undefined,
  legalEntityUserRolesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataLegalEntityUserRolesActions.loadLegalEntityUserRoles, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromStaticDataLegalEntityUserRolesActions.loadLegalEntityUserRolesSuccess, (state, action) => ({
    ...state,
    legalEntityUserRolesResponse: action.response
  })),

  on(fromStaticDataLegalEntityUserRolesActions.loadLegalEntityUserRolesFailure, (state, action) => ({
    ...state,
    legalEntityUserRolesFailure: action.error
  }))
);

export const getLegalEntityUserRolesResponse = (state: LegalEntityUserRolesState) => state.legalEntityUserRolesResponse;
export const getLegalEntityUserRolesFailure = (state: LegalEntityUserRolesState) => state.legalEntityUserRolesFailure;
export const getLegalEntityUserRolesIsLoaded = (state: LegalEntityUserRolesState) => state.loaded;
